import axios, { AxiosError } from 'axios';
import { SELF_SERVICE_API_URL } from 'config';
import type { SelfServiceAPI } from 'types';
import handleServiceError from '../utils/handleServiceError';

interface Data {
  bookingId: string;
  cancellationId: string;
}

interface Options {
  skipUnauthenticatedRedirection?: boolean;
  retry?: boolean;
}

const acceptCancellation = async (
  { bookingId, cancellationId }: Data,
  options: Options = {},
): Promise<SelfServiceAPI.AcceptCancellation.Response> => {
  try {
    const { data } = await axios.post<SelfServiceAPI.AcceptCancellation.Response>(
      `${SELF_SERVICE_API_URL}/bookings/${bookingId}/cancellations/${cancellationId}/accept`,
      undefined,
      {
        withCredentials: true,
      },
    );

    return data;
  } catch (error) {
    if (options.retry !== false) {
      const status = error instanceof AxiosError && error.response?.status;

      if (status === 500) {
        return await acceptCancellation({ bookingId, cancellationId }, { ...options, retry: false });
      }
    }

    handleServiceError(error, {
      operationName: `POST /bookings/${bookingId}/cancellations/${cancellationId}/accept`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default acceptCancellation;
